
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/my-account/status",
      function () {
        return require("private-next-pages/my-account/status.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/my-account/status"])
      });
    }
  